const getDefaultState = () => ({
  filtros: {
    grupos: [],

    fora_de_linha: true,
    inativo_revenda: true,
    produto_resgatado: true,
    venda_futura_maior_que_saldo_estoque: true,
    considerar_produtos_combinacao: window.location.pathname === '/diagnostico' ? false : true,
    primeira_entrada: [],
    ultima_entrada: [],
    idade: [],

    tipos_produtos: ['PRODUTOS_NAO_COMBINADOS', 'PRODUTOS_COMBINADOS'],

    compradores: [],
    fornecedores: [],
    linhas: [],
    segmentos: [],
    secoes: [],
    categorias: [],
    marcas: [],
    produtos: [],
    status_produto: [],
    status_estoque: [],
    pedidos_pendentes: [],
    histogramas: [],

    aplicacao: [],
    curva_faturamento: [],
    curva_popularidade: [],
    curva_rentabilidade: [],
  }
})

const state = getDefaultState()

const getters = {
  filtros(state) {
    return state.filtros
  },
  default_filtros() {
    return getDefaultState().filtros
  },
  filtros_formatados({ filtros }) {
    return {
      ...filtros,
      fora_de_linha: filtros.fora_de_linha ? 'S' : 'N',
      inativo_revenda: filtros.inativo_revenda ? 'S' : 'N',
      produto_resgatado: filtros.produto_resgatado ? 'S' : 'N',
      venda_futura_maior_que_saldo_estoque: filtros.venda_futura_maior_que_saldo_estoque ? 'S' : 'N',
    }
  }
}

const mutations = {
  filtros(state, valor) {
    state.filtros = valor
  },
  limpar_filtros(state) {
    const grupos = state.filtros.grupos

    const novo = getDefaultState()
    novo.filtros.grupos = grupos

    state.filtros = novo.filtros
  },
  filtros_grupos(state, valor){
    state.filtros.grupos = valor;
  }
}

const actions = {
  filtros: ({ commit }, valor) => {
    commit("filtros", valor)
  },
  limpar_filtros: ({ commit }, valor) => {
    commit("limpar_filtros", valor)
  },
  filtros_grupos: ({ commit }, valor) => {
    commit("filtros_grupos", valor);
  },
  syncRota({ state }) {
    const path = window.location.pathname    
    state.filtros.considerar_produtos_combinacao = path === '/diagnostico' ? false : true
  }
}

export default { namespaced: true, state, mutations, getters, actions }
